var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Thrown by recordService.deleteRecord / vocabularyService.deleteVocabulary on
 * a 409 BLOCKING_REFERENCES_EXIST response. Extends Error so unhandled cases
 * still surface in the console with a sensible message.
 */
var BlockingRefsError = /** @class */ (function (_super) {
    __extends(BlockingRefsError, _super);
    function BlockingRefsError(payload) {
        var _this = _super.call(this, payload.message) || this;
        _this.status = 409;
        _this.code = 'BLOCKING_REFERENCES_EXIST';
        _this.name = 'BlockingRefsError';
        _this.payload = payload;
        return _this;
    }
    return BlockingRefsError;
}(Error));
export { BlockingRefsError };
var isErrorWithResponse = function (error) {
    var _a;
    return (typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.json) === 'function');
};
var isDeleteBlockedPayload = function (body) {
    return (typeof body === 'object' &&
        body !== null &&
        'code' in body &&
        body.code === 'BLOCKING_REFERENCES_EXIST' &&
        'blockingReferences' in body);
};
/**
 * Try to parse the given error as a BLOCKING_REFERENCES_EXIST 409. Returns a
 * {@link BlockingRefsError} if it matches, otherwise null. Callers re-throw
 * the original error when the result is null.
 */
export var parseBlockingRefsError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var body, source, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!isErrorWithResponse(error)) {
                    return [2 /*return*/, null];
                }
                if (error.response.status !== 409) {
                    return [2 /*return*/, null];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                source = error.response.clone ? error.response.clone() : error.response;
                return [4 /*yield*/, source.json()];
            case 2:
                body = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, null];
            case 4:
                if (!isDeleteBlockedPayload(body)) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, new BlockingRefsError(body)];
        }
    });
}); };
/**
 * Type guard for callers that catch an `unknown`. **Brand check, deliberately not
 * `instanceof`.**
 *
 * <p>`instanceof BlockingRefsError` is false in the browser and true in jest, which is the
 * worst combination a guard can have. The webpack build targets ES5, where
 * `class X extends Error` becomes `function E(v){ var W = Error.call(this, v.message) || this; … }`
 * — and `Error.call(this, …)` ignores `this` and hands back a brand-new Error, so the
 * constructor returns an object whose prototype is `Error.prototype`, never `E.prototype`.
 * Verified in the deployed bundle (`bundle.stripes07458e4bc3fc193facde.js`), where the class
 * reads exactly like that. `name`, `message`, `code` and `payload` are all set correctly, so
 * the console shows a convincing `BlockingRefsError: …` while every `instanceof` against it is
 * false. Jest transpiles for node, keeps real classes, and cheerfully passes.
 *
 * <p>That is what made the delete dialog's blocked panel unreachable: `useDeleteRecord`
 * branched on `instanceof`, so a genuine 409 fell through to the `onError` path nobody passes,
 * and the modal sat there while react-query logged the error. It affected every record type —
 * this was never a vocabulary-only problem.
 *
 * <p>The brand is the same field the wire contract already uses and
 * {@link isDeleteBlockedPayload} already checks, so it survives transpilation, duplicated
 * module instances and structured cloning alike.
 */
export var isBlockingRefsError = function (error) {
    return (typeof error === 'object' &&
        error !== null &&
        error.code === 'BLOCKING_REFERENCES_EXIST' &&
        'payload' in error);
};
